import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from "../hooks/useSupabaseAuth"
import MultiStepIntakeFormV2 from './MultiStepIntakeFormV2';
import { useThemeClasses } from '../lib/themes/utils';

const IntakeFormWrapper: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth();
  const theme = useThemeClasses();

  // Show loading state while checking authentication
  if (isLoading) {
    return (
      <div className={`min-h-screen flex items-center justify-center ${theme.backgrounds.gradient}`}>
        <div className={`text-center ${theme.cards.elevated} p-8`}>
          <div className="relative">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto"></div>
            <div className="absolute inset-0 rounded-full h-12 w-12 border-2 border-primary-200 mx-auto"></div>
          </div>
          <p className={`mt-4 ${theme.text.neutral}`}>Loading your wellness journey...</p>
        </div>
      </div>
    );
  }

  // Redirect to intake page if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/intake" replace />;
  }

  // Render the form if authenticated
  return <MultiStepIntakeFormV2 />;
};

export default IntakeFormWrapper;